export default __webpack_public_path__ + "static/media/logo.5e4102c3.jpg";